import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InProgressMainComponent } from './in-progress-main/in-progress-main.component';
import { InProgressListComponent } from './in-progress-list/in-progress-list.component';
import { InProgressSidebarComponent } from './in-progress-sidebar/in-progress-sidebar.component';
import { RouterModule, Routes } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseSidebarModule } from '@fuse/components';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../../shared/shared.module';
import { SharedMaterialComponentsModule } from '../../../../shared-material-components.module';
import { InProgressDetailComponent } from './in-progress-detail/in-progress-detail.component';
import { AuthGuard } from 'app/shared/guards/auth/auth-guard.service';
import { NgxLoadingModule } from 'ngx-loading';
import { InProgressBoletoDetailComponent } from './in-progress-boleto-detail/in-progress-boleto-detail.component';
import { InProgressBoletoDetailListComponent } from './in-progress-boleto-detail-list/in-progress-boleto-detail-list.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { InProgressLancamentoListComponent } from './in-progess-lancamento-list/in-progress-lancamento-list.component';

const routes: Routes = [
  {
    path: '',
    component: InProgressMainComponent,
    resolve: {}
  },
  {
    path:'detail/:id',
    component:InProgressDetailComponent,
    resolve:{},
    canActivate: [AuthGuard]
  },
  {
    path:'boletos/:id',
    component: InProgressBoletoDetailComponent,
    resolve:{},
    canActivate: [AuthGuard]
  },
  {
    path:'lancamentos/:id',
    component:InProgressLancamentoListComponent,
    resolve:{},
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedMaterialComponentsModule,
    FuseSharedModule,
    FuseConfirmDialogModule,
    FuseSidebarModule,
    NgxDatatableModule,
    SharedModule,
    FlexLayoutModule,
    NgxLoadingModule.forRoot({}),
    NgxPermissionsModule.forRoot({})


  ],
  declarations: [
    InProgressMainComponent, 
    InProgressListComponent, 
    InProgressSidebarComponent, 
    InProgressDetailComponent, 
    InProgressBoletoDetailComponent,
    InProgressBoletoDetailListComponent,
    InProgressLancamentoListComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InProgressModule { }
